export default __webpack_public_path__ + "static/media/information.29745d78.svg";